import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { saveStateToLocalStorage, loadStateFromLocalStorage } from "../../localStorage";
import { LanguageState, LanguageCode } from "./languageTypes";
import { normalizeLanguageCode } from "../../../localization/supportedLanguages";

const detectInitialLanguage = (): LanguageCode => {
  const browserLang = navigator.language || (navigator as any).userLanguage;
  return normalizeLanguageCode(browserLang);
};

const initialState: LanguageState = loadStateFromLocalStorage("languageState") || {
  current: detectInitialLanguage(),
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<LanguageCode>) => {
      state.current = action.payload;
      saveStateToLocalStorage("languageState", state);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
